module.exports = __webpack_public_path__ + "static/media/LED.613a72dd.glb";